import { Typography } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type TypographySize,
  type TypographyType,
  type TypographyWeight,
  generateTypographyColorClassName,
  generateTypographySizeClassName,
  generateTypographyWeightClassName,
} from '../typography';

import { useGetType } from './hooks';
import styles from './paragraph.module.css';

export type ParagraphProperties = {
  size?: TypographySize;
  type?: TypographyType;
  weight?: TypographyWeight;
} & Omit<ComponentProps<typeof Typography.Paragraph>, 'type'>;

const Paragraph = ({ children, className, size, type, weight, ...rest }: ParagraphProperties) => {
  const { t } = useTranslation();
  const getType = useGetType();

  return (
    <Typography.Paragraph
      className={cn(
        className,
        styles.paragraph,
        generateTypographySizeClassName(size),
        generateTypographyWeightClassName(weight),
        generateTypographyColorClassName(type),
      )}
      type={getType(type)}
      {...rest}
    >
      {typeof children === 'string' ? t(children) : children}
    </Typography.Paragraph>
  );
};

export default Paragraph;
